import React, { useState, useEffect, useReducer } from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
} from "@coreui/react";
import CIcon from "@coreui/icons-react";
import AKFilterOption from "./AKFilterOption";

const reducer = (state, action) => {
  let stateToReturn = { keyFilters: [] };
  let keyFilters = [];
  switch (action.type) {
    case "toggle":
      for (const keyFilter of state?.keyFilters) {
        if (keyFilter.key === action.keyFilter.key) {
          stateToReturn.keyFilters.push(action.keyFilter);
        } else {
          stateToReturn.keyFilters.push(keyFilter);
        }
      }

      return stateToReturn;
    case "update":
      for (const option of action.options) {
        if (!option.hideFilterOption) {
          keyFilters.push({
            header: option.header,
            key: option.key,
            filterOn: action.searchKeys
              ? action.searchKeys.some((key) => key === option.key)
              : true,
          });
        }
      }

      stateToReturn.keyFilters = keyFilters;
      return stateToReturn;
    case "deselectAll":
      for (const option of action.options) {
        if (!option.hideFilterOption) {
          keyFilters.push({
            header: option.header,
            key: option.key,
            filterOn: false,
          });
        }
      }

      stateToReturn.keyFilters = keyFilters;
      return stateToReturn;
    case "selectAll":
      for (const option of action.options) {
        if (!option.hideFilterOption) {
          keyFilters.push({
            header: option.header,
            key: option.key,
            filterOn: true,
          });
        }
      }

      stateToReturn.keyFilters = keyFilters;
      return stateToReturn;
    default:
      break;
  }
};

const decodeQueryString = (queryString) => {
  return queryString.replace("%26", "&");
};

const encodeQueryString = (rawString) => {
  return rawString.replace("&", "%26");
};

const AKSearchBox = ({
  onSearchClick,
  options,
  queryString,
  setQueryString,
  searchKeys,
  searchButtonStyle,
}) => {
  let keyFilters = [];

  for (const option of options) {
    if (!option.hideFilterOption) {
      keyFilters.push({
        header: option.header,
        key: option.key,
        filterOn: searchKeys
          ? searchKeys.some((key) => key === option.key)
          : true,
      });
    }
  }

  const initialState = { keyFilters };

  const [showModal, setShowModal] = useState(false);
  const [searchString, setSearchString] = useState(
    queryString ? decodeQueryString(queryString) : ""
  );
  const [shouldDeselectAll, setShouldDeselectAll] = useState();
  const [state, dispatch] = useReducer(reducer, initialState);

  /**
   * Use Effect Hooks
   */

  useEffect(() => {
    let isMounted = true;

    let shouldDeselectAll = false;

    for (const filter of state.keyFilters) {
      if (filter.filterOn) {
        shouldDeselectAll = true;
      }
    }

    isMounted && setShouldDeselectAll(shouldDeselectAll);

    return () => {
      isMounted = false;
    };
  }, [state.keyFilters]);

  useEffect(() => {
    let isMounted = true;

    if (searchKeys && Array.isArray(searchKeys) && searchKeys.length > 0) {
      isMounted &&
        dispatch({
          type: "update",
          options,
          searchKeys,
        });
    }

    return () => {
      isMounted = false;
    };
  }, [searchKeys]);

  useEffect(() => {
    let isMounted = true;

    if (queryString) {
      isMounted && setSearchString(decodeQueryString(queryString));
    }

    return () => {
      isMounted = false;
    };
  }, [queryString]);

  const handleSearchChange = ({ target }) => {
    setSearchString(target.value);
  };

  const handleOnSearchClick = (event) => {
    event.preventDefault();

    let keys = [];

    for (const keyFilter of state?.keyFilters) {
      if (keyFilter.filterOn) {
        keys.push(keyFilter.key);
      }
    }

    if (event.target[1]) {
      setQueryString(event.target[1].value);
      onSearchClick(encodeQueryString(event.target[1].value), keys);
    } else {
      setQueryString(event.target.value);
      onSearchClick(encodeQueryString(event.target.value), keys);
    }
  };

  const handleToggleFilterClick = () => {
    setShowModal((prevShowModal) => !prevShowModal);
  };

  const handleToggleAllClick = () => {
    if (shouldDeselectAll) {
      dispatch({
        type: "deselectAll",
        options,
        searchKeys,
      });
    } else {
      dispatch({
        type: "selectAll",
        options,
        searchKeys,
      });
    }
  };

  return (
    <>
      <form className="d-flex align-self-end" onSubmit={handleOnSearchClick}>
        <button
          type="button"
          className={`ak-filter-button ${searchButtonStyle}`}
          onClick={handleToggleFilterClick}
        >
          <CIcon name="cil-filter" />
        </button>
        <input
          id="search-box"
          type="text"
          autoComplete="off"
          className="ak-search-box"
          min={0}
          name="search"
          aria-label="Search"
          placeholder="Search..."
          value={searchString}
          onChange={handleSearchChange}
        />
        <button type="submit" className={`${searchButtonStyle} search-button`}>
          <CIcon name="cil-search" /> Search
        </button>
      </form>
      <CModal
        show={showModal}
        closeOnBackdrop={false}
        onClose={handleToggleFilterClick}
        size="lg"
        className="ak-filter-modal"
      >
        <CModalHeader>
          <CModalTitle>Filters</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <form className="m-auto">
            {state?.keyFilters.map((keyFilter, index) => {
              return (
                <AKFilterOption
                  key={index}
                  keyFilter={keyFilter}
                  dispatch={dispatch}
                />
              );
            })}
          </form>
        </CModalBody>
        <CModalFooter>
          <CButton
            className={`ak-checkbox-button`}
            onClick={handleToggleAllClick}
          >
            {shouldDeselectAll ? "Deselect All" : "Select All"}
          </CButton>
          <CButton
            className={`ak-checkbox-button`}
            onClick={handleToggleFilterClick}
          >
            OK
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  );
};

export default AKSearchBox;
